export default class GrowCards {

	constructor() {

		this.settings = {
			$card : $('.js-grow-card')
		};

		this.bindUIActions();

	}

	bindUIActions() {

		if(this.settings.$card.length) {

			this.settings.$card.each(function() {

				if ($(window).width() > 1023) {
					$(this).hover(function () {
						$(this).siblings().removeClass('active');
						$(this).toggleClass('active');
					});
				} else {
					$(this).addClass('active');
				}

			});

		}

	}

};

new GrowCards();